import React from "react";
import { Col, Row, Modal, Card } from "antd";
import { Checked } from "../../../assets/icons";
import LetterAvatar from "../../../reusables/LetterAvatar";




const OrderSuccess = ({
    open, 
    onCancel, 
    user, 
    orderdetails, 
    merchantDetails, 
    carts, 
    onClick, 
    totalCustomerPoints, 
    word1, 
    merchant,
    isbranchSet,
    branch_address1,
    branch_address2,
    deliveryPrice,
    custAddress,
    serviceAmount,
    isReservedOrder,
    isBankTransferOrder
}) => {

    const activeLoyalty = localStorage.getItem("active_loyalty");
    const loyaltyActive = activeLoyalty ? JSON.parse(activeLoyalty) : null;

    const totalOrder = (cart) => {
        if (cart && cart.length === 0 ) return 0;
        const cartItemWithVariants = cart.filter((item)=>{
          return item.variants && item.variants.length > 0;
        });
    
        const cartItemsWithCust = cart.filter((item)=>{
          return item.custom_quantities && item.custom_quantities.length > 0;
        });
    
        const cartBundle = cart.filter((item)=>{
          return item.bundle_quantity && typeof item.bundle_quantity === "object";
        });
    
        const normItem = cart.filter((item)=>{
          return item.variants && item.variants.length === 0 && item.custom_quantities && item.custom_quantities.length === 0;
        });
        
        const totalVaraiant = cartItemWithVariants.reduce((prev, curr)=>{
          return Number(prev) + (Number(curr.quantity) * Number(curr.variants[0].price));
        }, 0);
    
        const totalCust = cartItemsWithCust.reduce((prev, curr)=>{
          return Number(prev) + (Number(curr.quantity) * Number(curr.custom_quantities[0].price));
        }, 0);
    
        const totalBundle = cartBundle.reduce((prev, curr)=>{
          return Number(prev) + (Number(curr.quantity) * Number(curr.price));
        }, 0);
    
        const otherTotal = normItem.reduce((prev, curr) => {
          return prev + Number(curr.quantity) * Number(curr.price);
        }, 0); 
    
        return deliveryPrice ? otherTotal + totalCust + totalVaraiant + totalBundle + Number(deliveryPrice) : otherTotal + totalCust + totalVaraiant + totalBundle;
      };

  return (
    <Modal
        open={open}
        // open={true}
        onCancel={onCancel}
        className="checkout_modal" 
        // onOk={()=>{
        //     dispatch(clearCart());
        //     setShowInStoreOrders(false);
        // }}
        footer={null}
    >
        <div style={{textAlign: "center", marginTop: "5px", lineHeight: "24.2px"}}>
            <p
                style={{fontSize: "20px",
                fontWeight: "600"}}
            >THANKS {user?.first_name ? user?.first_name.toUpperCase() : "New User"}, {word1}</p>
        </div>
        <div 
        style={{
                textAlign: "center", 
                marginTop: "5px", 
                display: "flex", 
                flexDirection: "column"
            }}>
            <span>
                    ORDER NUMBER
            </span>
            <span
                style={{fontSize: "32px",
                fontWeight: "600"}}
            >
                #{orderdetails?.order_id}
            </span>
        </div>
        <div style={{textAlign: "center", marginTop: "5px"}}>
            <img src={Checked} alt="checked"/>
        </div>
        {deliveryPrice ?
        <div style={{textAlign: "center", margin: "10px 0"}}>
            <span
                style={{fontSize: "13px",
                fontWeight: "500",
                lineHeight: "150%"
                }}
            >
                Order Completed. Please note your order number, your item(s) will be delivered to you at {custAddress}
            </span>
        </div> 
        : isReservedOrder ?
        <div style={{textAlign: "center", margin: "10px 0"}}>
            <span
                style={{fontSize: "13px",
                fontWeight: "500",
                lineHeight: "150%"
                }}
            >
                Order Reserved! Please note your order number and pickup location: 
                <br />
                <strong>{`${branch_address1 ? branch_address1 : merchantDetails?.address_line1}, ${branch_address2 ? branch_address2 : merchantDetails?.address_line2}`}</strong>
                <br />
                <span style={{color: "#ff6b35", fontWeight: "600", marginTop: "8px", display: "block"}}>
                    ⏰ This order will be held for 72 hours only
                </span>
            </span>
        </div>
        : isBankTransferOrder ?
        <div style={{textAlign: "center", margin: "10px 0"}}>
            <span
                style={{fontSize: "13px",
                fontWeight: "500",
                lineHeight: "150%"
                }}
            >
                Bank Transfer Order Created Successfully! 
                <br />
                <strong>Order Status: Pending Payment Verification</strong>
                <br />
                <span style={{color: "#1890ff", fontWeight: "600", marginTop: "8px", display: "block"}}>
                    📄 Your receipt has been uploaded for verification
                </span>
                <span style={{color: "#ff6b35", fontWeight: "600", marginTop: "4px", display: "block"}}>
                    ⏰ Payment verification can take a few mins, up to 24 hours
                </span>
                <span style={{color: "#666", fontSize: "11px", marginTop: "8px", display: "block"}}>
                    Orders will be cancelled if payment cannot be verified within 24 hours
                </span>
            </span>
        </div>
        :<div style={{textAlign: "center", margin: "10px 0"}}>
            <span
                style={{fontSize: "13px",
                fontWeight: "500",
                lineHeight: "150%"
                }}
            >
                Order Completed. Please note your order number, pickup and pay at the till at {merchantDetails?.role?.id === 1 ? " " : " "}, {`${branch_address1 ? branch_address1 : merchantDetails?.address_line1}, ${branch_address2 ? branch_address2 : merchantDetails?.address_line2}`}
            </span>
        </div>}
        <Card 
            className="instore_card"
        >
            <div>
            <h2 style={{textAlign: "center", color: "#0F0F10", fontSize: "14px", marginBottom: "-0.5rem"}}>ORDER SUMMARY</h2>
            </div>
            <Row>
                {orderdetails?.order_items && orderdetails?.order_items.map((cart, index)=>{
                    return <Col
                        key={index}
                        span={24}
                        lg={24}
                        md={24}
                        sm={24}
                        style={{
                            margin: "0",
                            padding: "15px 5px 0 0",
                            borderBottom: "1px solid #fff",
                        }}
                        >
                        <Row
                        
                        >
                            <Col span={8}>
                                {cart.picture ? (
                                    <img style={{ height: "64px", width: "64px", borderRadius: "50%", objectFit: "cover"}} src={cart.picture} alt={cart.name || "cart Image"}/>
                                ) : (
                                    <LetterAvatar name={cart.name} size={64} radius="50%" fontSize={26} />
                                )}
                            </Col>
                            <Col
                                span={8}
                                style={{display: "flex", flexDirection: "column"}}
                            >
                                
                                    <span>{cart.name}</span>
                                    {cart.variants && cart.variants.length !== 0 && cart.variants[0].value }
                                    {cart.custom_quantities && cart.custom_quantities.length !== 0 && cart.custom_quantities[0].name }
                                    {cart.products 
                                        && cart.products.length > 0 
                                        && cart.products.map((prod,index)=>{
                                            return <span style={{display: "inline-block"}}><b>{prod.name}</b>-{cart.bundle_quantity[index]} (units)</span>
                                        }) }
                                    <span
                                    style={{fontSize: "11px", opacity: "0.3"}}>
                                        {cart.variants && cart.variants.length > 0 ? Number(cart.variants[0].price).toFixed(2) : cart.custom_quantities && cart.custom_quantities.length > 0 ?  Number(cart.custom_quantities[0].price).toFixed(2) : Number(cart.price).toFixed(2)} x {cart.quantity}
                                        </span>
                            </Col>
                            <Col 
                                span={8}
                                style={{textAlign: "right", fontSize: "13px", fontWeight: "light"}}
                            >
                                <span>
                                {cart.variants && cart.variants.length > 0 ? (
                                    Number(cart.variants[0].price) * Number(cart.quantity)
                                ).toFixed(2) : cart.custom_quantities && cart.custom_quantities.length > 0 ? (
                                    Number(cart.custom_quantities[0].price) * Number(cart.quantity)
                                ).toFixed(2) : (
                                    Number(cart.price) * Number(cart.quantity)
                                ).toFixed(2)}
                                    </span>
                            </Col>
                        </Row>
                        
                    </Col>
                    
                    
                })}
                
            </Row>
            <Row>
               {deliveryPrice && (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%"
                    }}
                >
                    <p style={{margin: 0, color: "#6B6B76"}}>Delivery Fee</p>
                    <p style={{margin: 0, color: "#0F0F10"}}>{deliveryPrice}</p>
                </div>
               )}
            </Row>
            <div 
                style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: "1rem"
                }}
            >
                <span 
                style={{ 
                    color: "#0F0F10", 
                    fontSize: "14px"
                }}
                >TOTAL: {merchantDetails?.currency || merchant?.currency}{" "} {totalOrder(carts).toFixed(2)} </span>

                {activeLoyalty && <span style={{fontSize: "11px", opacity: "0.5"}}>
                    You will earn {" "}
                    {Math.floor(totalOrder(carts) / (Number(loyaltyActive?.currency_value) / Number(loyaltyActive?.points))) + " pts"}
                </span>}
            </div>
        </Card>
        <div style={{textAlign: "center", paddingTop: "1rem"}}>
        {/* <Link to={merchantUrl}> */}
        <p
            style={{fontSize: "12px", fontWeight: "600", margin: "0"}}
            onClick={onClick}
            className="cart_action"
            >See Your Loyalty Rewards Balance</p>
        {/* </Link> */}
        </div>
    </Modal>
  )
}

export default OrderSuccess;